import React from 'react';
import Routes from '../../Components/Routes';
import PaymentListener from '../../Services/PaymentListener';

const App = () => {
  return (
    <>
      <PaymentListener />
      <Routes />
    </>
  );
};

export default App;
